export default __webpack_public_path__ + "static/tag-dont-5-dark-24a3f95be6fcc45dc2d9d6f78303fb57d52fc549f2837982579f51fe8933a19f.png";